import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStatus } from 'features/auth';
import { isImpersonationHonored, mayControlImpersonation } from './decision';
import { getImpersonationModule } from './install';
import { useImpersonationEmail } from './useImpersonation';
export default function ImpersonationPanel() {
    const { t } = useTranslation();
    const status = useAuthStatus();
    const activeEmail = useImpersonationEmail();
    const [draft, setDraft] = useState(activeEmail);
    const [message, setMessage] = useState('');
    useEffect(() => {
        setDraft(activeEmail);
    }, [activeEmail]);
    // ROWILABDEV-72: while impersonating, `subject` is the impersonated user — gate the
    // controls by whether the impersonation was honored (admin behind it), not by subject.
    if (status.kind !== 'authenticated' || !mayControlImpersonation(status.user, activeEmail)) {
        return null;
    }
    const impersonating = isImpersonationHonored(status.user.email, activeEmail);
    const save = () => {
        const normalized = draft.trim();
        getImpersonationModule().setEmail(normalized);
        setMessage(normalized ? t('status_impersonating', { email: normalized }) : t('status_impersonation_cleared'));
    };
    const clear = () => {
        getImpersonationModule().setEmail('');
        setDraft('');
        setMessage(t('status_impersonation_cleared'));
    };
    return (_jsxs("section", { className: "flex flex-col gap-2.5 rounded-lg border border-[#d1d5dc] p-3.5", children: [_jsx("h3", { className: "m-0 text-[16px] font-semibold leading-6 text-[#0a0a0a]", children: "Impersonation" }), impersonating && (_jsx("p", { className: "m-0 rounded-md bg-primary-005 px-3 py-2 text-[14px] leading-5 text-primary", children: t('status_impersonating', { email: activeEmail }) })), _jsx("input", { onChange: (event) => setDraft(event.target.value), placeholder: "Agent email for impersonation", className: "min-h-10 w-full rounded-md border border-[#99a1af] px-3 py-2 text-[14px] leading-5 text-[#0a0a0a] outline-none", type: "email", value: draft }), _jsxs("div", { className: "flex flex-wrap gap-2.5", children: [_jsx("button", { onClick: save, className: "min-h-10 rounded-md border border-[#1d4ed8] bg-[#2563eb] px-3 py-2 text-[14px] leading-5 text-white", type: "button", children: "Save impersonation" }), _jsx("button", { onClick: clear, className: "min-h-10 rounded-md border border-[#99a1af] bg-white px-3 py-2 text-[14px] leading-5 text-[#0a0a0a]", type: "button", children: "Clear impersonation" })] }), message && _jsx("p", { className: "m-0 text-[14px] leading-5 text-[#1d4ed8]", children: message })] }));
}
